/* eslint-disable import/first */
import React from 'react';
import { Grid, Paper } from '@material-ui/core';
import Accordion from '../../components/Accordion';
import css from './index.module.scss';

const FaqContainer = ({ faqList }) => {
  // const [online, setOnlineActive] = useState(true);
  // const [restaurants, setRestaurantsActive] = useState(false);
  // const [employment, setEmploymentActive] = useState(false);
  // eslint:fix

  // const onItemClick = (value) => {
  //   switch (value) {
  //     case 'online':
  //       setOnlineActive(!online);
  //       setRestaurantsActive(false);
  //       setEmploymentActive(false);
  //       break;

  //     case 'restaurants':
  //       setRestaurantsActive(!restaurants);
  //       setOnlineActive(false);
  //       setEmploymentActive(false);
  //       break;

  //     case 'employment':
  //       setEmploymentActive(!employment);
  //       setOnlineActive(false);
  //       setRestaurantsActive(false);
  //       break;

  //     default:
  //       break;
  //   }
  // };
  // eslint:fix onItemClick is defined but is never used
  return (
    <Grid>
      {/* <Toolbar className={css.toolBar}>
        <Grid
          className={online ? css.tabItem : css.notActive}
          onClick={() => onItemClick('online')}
        >
          <Grid>Online Ordering</Grid>
          <Grid className={online ? css.active : css.notActive} />
        </Grid>
        <Grid
          className={restaurants ? css.tabItem : css.notActive}
          onClick={() => onItemClick('restaurants')}
        >
          <Grid>Restaurants</Grid>
          <Grid className={restaurants ? css.active : css.notActive} />
        </Grid>
        <Grid
          className={employment ? css.tabItem : css.notActive}
          onClick={() => onItemClick('employment')}
        >
          <Grid>Employment</Grid>
          <Grid className={employment ? css.active : css.notActive} />
        </Grid>
      </Toolbar> */}
      <Grid className={css.root}>
        {faqList.map((each, i) => {
          return (
            <Paper key={i}>
              <Accordion title={each.ques} desc={each.ans} />
            </Paper>
          );
        })}
      </Grid>
    </Grid>
  );
};

export default FaqContainer;
